import React, { useEffect, useState } from "react";
import { IMAGES } from "../../../../../assets/images";
import { useNavigate } from "react-router-dom";
import { routerPath } from "../../../../navigation/path";
import CustomButton from "../../../../components/button";
import { useDispatch, useSelector } from "react-redux";
import { getMembersipList, purchaseMembership } from "../../services";
import { toast } from "react-toastify";
import { setToken } from "../../../../../store/slices/userSlice";
import { Modal } from "react-bootstrap";
import { getTermsAndCondition } from "../../../services";
import Header from "../../../header/header";
import Footer from "../../../footer/footer";

const PurchasePlan = () => {
  const [selectedPlan, setSelectedPlan] = useState({});
  const [coupon, setCoupon] = useState("");
  const [membershipList, setMembershipList] = useState([]);
  const [termsAccept, setTermsAccept] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.users.user);
  const isLoggedIn = useSelector((state) => !!state.users.token);

  useEffect(() => {
    MembershipList();
    getTermsAndConditions();
  }, []);

  const [TermsAndConditions, setTermsAndConditions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {}, []);

  const MembershipList = async () => {
    try {
      const res = await getMembersipList();
      console.log(res);
      setMembershipList(res.data);
      setSelectedPlan(res.data[0]);
    } catch (err) {
      console.log(err);
    }
  };

  const getTermsAndConditions = async () => {
    try {
      const res = await getTermsAndCondition("terms_and_conditions");
      console.log(res.data[0]);
      await setTermsAndConditions(res.data[0]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const subscribeMembership = async () => {
    console.log(coupon, selectedPlan, termsAccept);
    const playload = {
      name: user.name,
      mobile: user.mobile,
      email: user.email,
      code: coupon,
      membership_id: selectedPlan.id,
      gst_number: "",
    };
    try {
      setIsLoading(true);
      const res = await purchaseMembership(playload);
      toast.success(res.message);
      setIsLoading(false);
      dispatch(setToken(user.token));
    } catch (err) {
      setIsLoading(false);
    }

    // navigate(routerPath.home)
  };
  const termsChanged = () => {
    const terms = document.getElementById("terms");
    setTermsAccept(terms.checked);
  };
  return (
    <>
      {isLoggedIn && <Header />}
      <div className="flex flex-col lg:flex-row min-h-screen bg-gray-50">
        {/* Left Section */}
        <div className="w-full lg:w-[60%] bg-white px-4 sm:px-8 md:px-12 lg:px-20 py-8 sm:py-12 lg:py-16 shadow-md overflow-y-auto">
          <div className="w-full lg:w-[90%] m-auto">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
              Upgrade to Platinum
            </h1>
            <p className="text-sm sm:text-base text-gray-500 mb-4 sm:mb-6">
              Do more with unlimited blocks, files, automations & integrations.
            </p>
          </div>

          <form className="w-full lg:w-[90%] m-auto">
            {/* Input Fields */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
              <div>
                <label
                  htmlFor=""
                  className="text-xs sm:text-sm mb-2 ml-2 block"
                >
                  Name
                </label>
                <input
                  type="text"
                  placeholder="First name"
                  className="w-full border border-gray-300 rounded-md p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  value={user?.name}
                  readOnly={true}
                />
              </div>
              <div>
                <label
                  htmlFor=""
                  className="text-xs sm:text-sm mb-2 ml-2 block"
                >
                  Phone
                </label>
                <input
                  type="tel"
                  placeholder="Phone"
                  className="w-full border border-gray-300 rounded-md p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  value={user?.mobile}
                  readOnly={true}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4">
              <div>
                <label
                  htmlFor=""
                  className="text-xs sm:text-sm mb-2 ml-2 block"
                >
                  Email address
                </label>
                <input
                  type="email"
                  placeholder="Email address"
                  className="w-full border border-gray-300 rounded-md p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                  value={user?.email}
                  readOnly={true}
                />
              </div>
              <div>
                <label
                  htmlFor=""
                  className="text-xs sm:text-sm mb-2 ml-2 block"
                >
                  GST Number (optional)
                </label>
                <input
                  type="tel"
                  placeholder="GST Number (optional)"
                  className="w-full border border-gray-300 rounded-md p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            </div>

            {/* Terms & Conditions */}
            <div className="flex items-center mb-6">
              <input
                type="checkbox"
                id="terms"
                className="mr-2 h-4 w-4 rounded"
                onChange={termsChanged}
                value="yes"
              />
              <label
                htmlFor="terms"
                className="text-sm text-gray-600 select-none"
              >
                I have read and agree to the website{" "}
                <span
                  className="text-blue-500 hover:underline cursor-pointer"
                  onClick={() => setShowModal(true)}
                >
                  Terms & Conditions
                </span>
              </label>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button
                type="button"
                className="w-full sm:w-1/3 py-3 h-[50px] rounded-xl bg-gray-200 text-gray-600 hover:bg-gray-300 transition"
              >
                Cancel
              </button>

              <CustomButton
                title={"Subscribe"}
                loader={isLoading}
                buttonStyle="w-full sm:w-2/3 h-[50px] rounded-xl"
                disabled={(!isLoggedIn && coupon == "") || !termsAccept}
                onClick={subscribeMembership}
              />
            </div>
          </form>
        </div>

        {/* Right Section */}
        <div className="w-full lg:w-[40%] bg-[#EDF2F5] px-4 sm:px-8 md:px-12 lg:px-20 py-8 sm:py-12 flex justify-center items-start overflow-y-auto">
          {/* Coupon Input */}
          <div className="w-full">
            <>
              <p htmlFor="" className="text-xs sm:text-sm ml-2 mb-2">
                If you have a coupon code, please apply it below.
              </p>
              <div className="flex items-center gap-2 mb-4 sm:mb-6">
                <input
                  type="text"
                  placeholder="Coupon code"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  className="w-[100%] border border-gray-300 h-[50px] rounded-md p-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                />

                {/* <CustomButton title={'Apply Coupon'} loader={false} buttonStyle="w-[40%] h-[50px]" disabled={coupon == ''} /> */}
              </div>
            </>

            {/* Starter Plan */}
            <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">
              Starter Plan
            </h2>

            {/* Plan Options */}
            <div className="space-y-4">
              {membershipList.map((plan) => (
                <div
                  key={plan.id}
                  className={`p-3 border rounded-md cursor-pointer ${
                    selectedPlan.id === plan.id
                      ? "border border-red-500 bg-[rgba(6,115,234,0.1)]"
                      : "border-gray-300"
                  }`}
                  onClick={() => setSelectedPlan(plan)}
                >
                  <div className="flex justify-between items-center">
                    <div className="w-[10%] flex-shrink-0">
                      {selectedPlan.id === plan.id ? (
                        <img
                          src={IMAGES.RadioSelected}
                          alt=""
                          className="w-5 h-5"
                        />
                      ) : (
                        <img src={IMAGES.Radio} alt="" className="w-5 h-5" />
                      )}
                    </div>
                    <div className={`${plan.discount ? "w-[70%]" : "w-[90%]"}`}>
                      <p className="text-base sm:text-lg font-semibold mb-1">
                        {plan?.name}
                      </p>
                      <p className="text-gray-500 text-xs sm:text-sm mb-0">
                        ₹ {plan?.prize} / {plan?.validity_days} days
                      </p>
                    </div>
                    {/* {plan.discount && (
                                        <span className="text-blue-600 text-xs font-semibold w-[10%]">
                                            {plan.discount}
                                        </span>
                                    )} */}
                  </div>
                </div>
              ))}
            </div>

            {/* Total Section */}
            <div className="mt-6 sm:mt-8">
              <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 sm:w-[50%]">
                  Total
                </h3>
                <p className="text-xl sm:text-2xl font-bold text-gray-800 sm:text-right sm:w-[50%]">
                  ₹ {selectedPlan?.prize} / {selectedPlan?.validity_days} days
                </p>
              </div>
              <p className="text-xs sm:text-sm text-gray-500 mt-2">
                Your personal data will be used to process your order, support
                your experience throughout this website, and for other purposes
                described in our Privacy Policy.
              </p>
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Terms and Condition</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              dangerouslySetInnerHTML={{ __html: TermsAndConditions.content }}
            ></div>
          </Modal.Body>
        </Modal>
      </div>
      {isLoggedIn && <Footer />}
    </>
  );
};

export default PurchasePlan;
